/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationVisibilityResponse {
    getFixupPrototypeFunction() { return OperationVisibilityResponse.fixupPrototype; }

    static newInstance(model: Partial<OperationVisibilityResponse>): OperationVisibilityResponse {
        let obj = Object.assign(new OperationVisibilityResponse(), model);
        OperationVisibilityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationVisibilityResponse>): OperationVisibilityResponse {
        if (!model) return null;
        return OperationVisibilityResponse.newInstance(<OperationVisibilityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationVisibilityResponse) {
        if (!obj) return;

        models.OperationVisibilityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationVisibilityResponse): boolean {
        Object.setPrototypeOf(obj, OperationVisibilityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.account_wise_count) {
            for (let val of this.account_wise_count) {
                models.OperationAccountModel.fixupPrototype(val);
            }
        }
        if (this.resource_wise_count) {
            for (let val of this.resource_wise_count) {
                models.OperationResourceModel.fixupPrototype(val);
            }
        }
        if (this.region_wise_count) {
            for (let val of this.region_wise_count) {
                models.OperationRegionModel.fixupPrototype(val);
            }
        }
        if (this.resource_group_wise_count) {
            for (let val of this.resource_group_wise_count) {
                models.OperationResourceGroupModel.fixupPrototype(val);
            }
        }
        if (this.zone_wise_count) {
            for (let val of this.zone_wise_count) {
                models.ZoneModel.fixupPrototype(val);
            }
        }
        if (this.resource_list_data) {
            for (let val of this.resource_list_data) {
                models.OperationResourceListModel.fixupPrototype(val);
            }
        }
    }

    /**
     * count details
     */
    total_count: number;

    /**
     * List of account wise count data
     */
    account_wise_count: Array<models.OperationAccountModel>;

    /**
     * List of resource wise count data
     */
    resource_wise_count: Array<models.OperationResourceModel>;

    /**
     * List of region wise count data
     */
    region_wise_count: Array<models.OperationRegionModel>;

    /**
     * List of resource group wise data
     */
    resource_group_wise_count: Array<models.OperationResourceGroupModel>;

    /**
     * List of zone wise count data
     */
    zone_wise_count: Array<models.ZoneModel>;

    /**
     * List of account wise count data
     */
    resource_list_data: Array<models.OperationResourceListModel>;

}
